export const modifierPrice = ( price ) => {
	return price.toLocaleString( 'ru' );
};
